import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {VImageDropComponent} from "../v-image-drop/v-image-drop.component";
import {VetClinic, VetClinicPhotoGalleryImage, VetDoctor, VImage} from "../../models/vet-clinic.model";
import {AppStateService} from "../../providers/app-state.service";
import {VetClinicService} from "../../providers/vet-clinic.service";
import {CommonUtils} from "../../utils/common";
import {VisitType} from "../../models/vet-clinic-data.model";
import {FileService} from "../../providers/file.service";
import {InputChangeEventDetail, ItemReorderEventDetail, ModalController} from "@ionic/angular";
import {Subscription} from "rxjs";
import {VetClinicInfoData} from "../../models/vet-clinic-info-data.model";
import {User} from "../../models/user.model";
import {Client} from "../../models/client.model";
import {UserService} from "../../providers/user.service";
import {ClientsService} from "../../providers/clients.service";
import {UnsavedChangesGuard} from "../../providers/unsaved-changes.guard";
import {timeValidator} from "../../utils/form-validators";

@Component({
  selector: 'app-clinic-info-edit',
  templateUrl: './clinic-info-edit.component.html',
  styleUrls: ['./clinic-info-edit.component.scss'],
})
export class ClinicInfoEditComponent implements OnInit {
  @Input()
  vetClinic: VetClinic;
  isBusySub: Subscription;
  @Output()
  vetClinicEditedEmitter: EventEmitter<VetClinic> = new EventEmitter<VetClinic>();
  @Output()
  cancelVetClinicEditedEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
  hasUnsavedChangesEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

  cityRegions = [
    'dolnośląskie',
    'kujawsko-pomorskie',
    'lubelskie',
    'lubuskie',
    'łódzkie',
    'małopolskie',
    'mazowieckie',
    'opolskie',
    'podkarpackie',
    'podlaskie',
    'pomorskie',
    'śląskie',
    'świętokrzyskie',
    'warmińsko-mazurskie',
    'wielkopolskie',
    'zachodniopomorskie'
  ];

  vetClinicGroup: FormGroup;

  vetClinicInfoData: VetClinicInfoData;

  servicesItems: string[];
  services: string[];

  vImages: VImage[];
  vImagesSub: Subscription;

  partnerAction: string;

  hasUnsavedChanges: boolean = false;
  advancedSettingsOpened: boolean = false;

  isAdmin: boolean;
  isGeneralAdmin: boolean;
  loggedUser: User;
  partners: Client[];
  partnerUUID: string;
  partner: Client;
  partnerToChange: Client;
  images: VImage[];
  vc: VetClinic;
  linkedReservationDoctors: VetDoctor[];
  addPartner: boolean;
  selectedGVisitType: any;
  vTypes: VisitType[] = [];
  isBusy: boolean;
  paymentsEnabled: boolean;
  messagesEnabled: boolean;

  voucherInfoFirstInSubject: boolean;
  vetClinicGallery: VImage[] | VetClinicPhotoGalleryImage[];
  vrAutoLockMode: boolean;
  vrAutoLockEndHour: string;
  isOldRecommendationsSyncBlocked: boolean;
  isOldLabTestDataBlocked: boolean;
  isSendExtendedNotifications: boolean;
  sendVisitTypeAdditionalInfo: boolean;

  visitSyncHourMode: boolean = false;
  visitSyncHour: string;
  startSyncDate: string;
  reservationCancellationRefund: number;
  maxReservationCancellation: string;
  legalVersion: boolean;
  visitUpdateSyncPushBlock: boolean;
  visitUpdateSyncPushBlockValue: any;
  pushBlockValueRegex: RegExp = new RegExp(/^[1-8]$/);
  private alertPresented: boolean = false;
  showAllFreeTerms: boolean;
  disableCheckKlinikaXpSync: boolean;
  useCustomSchedule: boolean;
  isGeneralClientAdmin: boolean;
  pragmaticBoxProgram: boolean;
  selectedCityRegion: string;
  cityName: string;

  constructor(private appStateService: AppStateService, private vetClinicService: VetClinicService
    , private commonUtils: CommonUtils, private formBuilder: FormBuilder, private fileService: FileService, private modalController: ModalController,
              private userService: UserService, private clientsService: ClientsService,
              private unsavedChangesGuard: UnsavedChangesGuard
  ) {
  }

  numericOnly(event): boolean {
    const pattern = /^([0-9])$/;
    const result = pattern.test(event.key);
    return result;
  }

  isHour(str: string) {
    const pattern = /^[0-9]{2}:[0-9]{2}$/;
    const result = pattern.test(str);
    return result;
  }

  ngOnInit() {
    this.vetClinicGallery = [];
    this.vetClinicGallery = this.vetClinic.gallery?.map((i)=>i);

    this.partnerAction = 'przypisz partnera';
    this.appStateService.updateIsBusySubject(true);
    this.userService.getUser().subscribe(u => {
        if (u !== null) {
          this.loggedUser = u;
          this.isAdmin = u.roles?.split(';').filter(e => e === 'admin').length === 1;
          this.isGeneralAdmin = this.isAdmin && u.vClientId === null && u.vetcodeId === null;
          this.isGeneralClientAdmin = u.roles?.split(';').filter(e => e === 'clients').length === 1 && u.vClientId === null && u.vetcodeId === null;
          if (this.isGeneralAdmin) {
            this.clientsService.listAllPartners().subscribe(p => {
              if (p) {
                this.partners = p;
                this.partner = this.partners?.filter(e => e.id === this.vetClinic?.partnerVClientId)[0];
              }
            })
          }
          this.appStateService.updateIsBusySubject(false);

        }
      }
    );

    this.isBusySub = this.appStateService.isBusySubject.subscribe(isBusy => {
      this.isBusy = isBusy;
      if (isBusy) {
        if (this.vetClinicGroup) {
          this.vetClinicGroup.disable();
        }
      } else {
        if (this.vetClinicGroup) {
          this.vetClinicGroup.enable();
        }
      }
    });

    // console.log(e);
    this.vTypes = this.vetClinic.visitTypes;
    this.selectedGVisitType = 'all-types';

    this.voucherInfoFirstInSubject = this.vetClinic.voucherInfoFirstInSubject;
    this.paymentsEnabled = this.vetClinic.paymentsEnabled;
    this.messagesEnabled = this.vetClinic.messagesEnabled;
    this.vrAutoLockMode = this.vetClinic?.vrAutoLockMode === 1;
    this.vrAutoLockEndHour = this.vetClinic.vrAutoLockEndHour;
    this.useCustomSchedule = this.vetClinic.useCustomSchedule;

    this.selectedCityRegion = this.vetClinic.cityRegion;
    this.cityName = this.vetClinic.cityName;

    this.vetClinic.visitTypes.forEach(visitType => {
      let vetVisitType = this.vetClinic?.vetVisitTypes?.filter(e => e.klinikaXpVisitId === visitType.xid)[0];
      if (vetVisitType === undefined) {
        return visitType;
      } else {
        visitType.prepaidPrice = vetVisitType?.prepaidPrice
        visitType.online = vetVisitType?.online
        visitType.prepaidRequired = vetVisitType?.prepaidRequired
        return visitType
      }
    })

    if(this.paymentsEnabled){
     this.reservationCancellationRefund =  this.vetClinic.reservationCancellationRefund;
    }

    if(!this.vetClinic.legalVer|| this.vetClinic.legalVer === 'V1'){
      this.legalVersion = false;
    } else {
      this.legalVersion = true;
    }

    if(this.vetClinic.dateSinceSyncVisitStarted){
     this.startSyncDate = new Date(new Date(this.vetClinic.dateSinceSyncVisitStarted).getTime() + 7200000).toISOString();
    }

    this.linkedReservationDoctors = this.vetClinic.team?.filter(e => e.hasLinkedReservation);
    if(this.isGeneralAdmin || this.isGeneralClientAdmin){
      this.vetClinicGroup = this.formBuilder.group({
        homeImageUUID: [this.vetClinic.homeImageUUID],
        vMsgDefaultImg: [this.vetClinic.vMsgDefaultImg],
        about: [this.vetClinic.about, Validators.required],
        servicesJson: [this.vetClinic.services],
        sendTechnicalAlerts: [this.vetClinic.sendTechnicalAlerts],
        technicalAlertsEmail: [this.vetClinic.technicalAlertsEmail, Validators.email],
        hoursToSendReminder: [this.vetClinic.hoursToSendReminder],
        cancellationPageUrl: [this.vetClinic.cancellationPageUrl, Validators.required],
        invoiceOfficeEmail: [this.vetClinic.invoiceOfficeEmail, Validators.email],
        percentageRefundValueAfterExpiration: [this.vetClinic.percentageRefundValueAfterExpiration],
        voucherSellInfo: [this.vetClinic.voucherSellInfo],
        paymentsEnabled: [this.vetClinic.paymentsEnabled],
        messagesEnabled: [this.vetClinic.messagesEnabled],
        displayName: [this.vetClinic.displayName],
        voucherInfoFirstInSubject: [this.vetClinic.voucherInfoFirstInSubject],
        vetineoPromotionEmailAddon: [this.vetClinic.vetineoPromotionEmailAddon],
        sendConfirmNotification: [this.vetClinic.sendConfirmNotification],
        visitSyncDelayMinutes: [this.vetClinic.visitSyncDelayMinutes],
        pragmaticBoxCode: [this.vetClinic.pragmaticBoxCode],
        visitSyncHour: [this.vetClinic.visitSyncHour, timeValidator]
      });
    } else {
      this.vetClinicGroup = this.formBuilder.group({
        homeImageUUID: [this.vetClinic.homeImageUUID],
        vMsgDefaultImg: [this.vetClinic.vMsgDefaultImg],
        about: [this.vetClinic.about, Validators.required],
        servicesJson: [this.vetClinic.services],
        sendTechnicalAlerts: [this.vetClinic.sendTechnicalAlerts],
        technicalAlertsEmail: [this.vetClinic.technicalAlertsEmail, Validators.email],
        hoursToSendReminder: [this.vetClinic.hoursToSendReminder],
        // cancellationPageUrl: [this.vetClinic.cancellationPageUrl, Validators.required],
        invoiceOfficeEmail: [this.vetClinic.invoiceOfficeEmail, Validators.email],
        percentageRefundValueAfterExpiration: [this.vetClinic.percentageRefundValueAfterExpiration],
        voucherSellInfo: [this.vetClinic.voucherSellInfo],
        voucherInfoFirstInSubject: [this.vetClinic.voucherInfoFirstInSubject],
        vetineoPromotionEmailAddon: [this.vetClinic.vetineoPromotionEmailAddon],
        sendConfirmNotification: [this.vetClinic.sendConfirmNotification],
        visitSyncDelayMinutes: [this.vetClinic.visitSyncDelayMinutes],
        pragmaticBoxCode: [this.vetClinic.pragmaticBoxCode],
        visitSyncHour: [this.vetClinic.visitSyncHour, timeValidator]
      });
    }

    if (this.vetClinic?.services) {
      this.services = JSON.parse(this.vetClinic.services);
      this.servicesItems = JSON.parse(this.vetClinic.services);
    } else {
      this.services = [];
    }

    this.vImagesSub = this.fileService.getVImages(false, this.vetClinic?.vetcodeId.toString())
      .subscribe(images => {
      this.vImages = images;
    });
    this.vc = JSON.parse(JSON.stringify(this.vetClinic));

    if(this.vetClinic.isOldRecommendationsSyncBlocked !=null){
      this.isOldRecommendationsSyncBlocked= this.vetClinic.isOldRecommendationsSyncBlocked;
    }

    if(this.vetClinic.isOldLabTestDataBlocked !=null){
      this.isOldLabTestDataBlocked= this.vetClinic.isOldLabTestDataBlocked;
    }

    if(this.vetClinic?.showAllFreeTerms===null || this.vetClinic?.showAllFreeTerms === undefined){
      this.showAllFreeTerms = true;
    } else {
      this.showAllFreeTerms = this.vetClinic.showAllFreeTerms;
    }

    if(this.vetClinic?.disableCheckKlinikaXpSync){
      this.disableCheckKlinikaXpSync = true;
    } else {
      this.disableCheckKlinikaXpSync = false;
    }

    if(this.vetClinic.sendExtendedNotifications != null) {
      this.isSendExtendedNotifications = this.vetClinic.sendExtendedNotifications;
    }

    if(this.vetClinic.sendVisitTypeAdditionalInfo != null){
      this.sendVisitTypeAdditionalInfo = this.vetClinic.sendVisitTypeAdditionalInfo;
    }
    if(this.vetClinic.visitUpdateSyncPushBlock != null){
      this.visitUpdateSyncPushBlock = this.vetClinic.visitUpdateSyncPushBlock;
      if(this.visitUpdateSyncPushBlock) {
        this.visitUpdateSyncPushBlockValue = this.vetClinic.visitUpdateSyncPushBlockValue;
      }
    }

    if(this.vetClinic.visitSyncHourMode != null) {
      this.visitSyncHourMode = this.vetClinic.visitSyncHourMode;
    }

    this.appStateService.updateIsBusySubject(false);
  }

  reorderServices(event: CustomEvent<ItemReorderEventDetail>) {
    this.services = this.commonUtils.immutableArrayMove(this.services, event.detail.from, event.detail.to);
    this.servicesItems = this.commonUtils.immutableArrayMove(this.servicesItems, event.detail.from, event.detail.to);
    this.vetClinicGroup.get('servicesJson').setValue(JSON.stringify(this.servicesItems));
    this.markUnsavedChanges();
    event.detail.complete();
  }

  isFormFieldInvalid(form: FormGroup, fieldName: string, validationType: string) {
    return this.commonUtils.isFormFieldInvalid(form, fieldName, validationType);
  }

  async openImageDropForPhoto(formControlName: 'homeImageUUID', imageFolder: string) {
    const modal = await this.modalController.create({
      component: VImageDropComponent,
      componentProps: {
        'multiple': false,
        'vetClinicUUID': this.vetClinic.uuid,
        'imageFolder': imageFolder
      }
    });

    modal.onDidDismiss<VImage>().then((dismissData) => {
      if (dismissData && dismissData.data !== null) {
        if (formControlName === 'homeImageUUID') {
          this.vetClinic.homeImage = dismissData.data;
        }

        if (this.images) {
          this.images.push(dismissData.data);
        } else {
          this.images = [];
          this.images.push(dismissData.data);
        }

        this.vetClinicGroup.get(formControlName).setValue(dismissData.data?.uuid);
        this.markUnsavedChanges();
      }
    });

    return await modal.present();
  }

  changePartner(uuid: string) {
    this.partnerUUID = uuid;
    this.partnerToChange = this.partners?.filter(e => e.uuid === uuid)[0];
  }

  onPartnerAction() {
    this.addPartner = !this.addPartner;
    if (this.addPartner) {
      this.partnerAction = 'anuluj przypisywanie partnera'
    } else {
      this.partnerAction = 'przypisz partnera'
    }
  }


  revertImage(valueToRevert: string, image: VImage) {
    if (valueToRevert === 'vMsgDefaultImg') {
      this.vetClinic.vMsgDefaultImgUUID = this.vc.vMsgDefaultImgUUID;
      this.vetClinic.vMsgDefaultImg = this.vc.vMsgDefaultImg;
    }
    if (valueToRevert === 'homeImage') {
      this.vetClinic.homeImageUUID = this.vc.homeImageUUID;
      this.vetClinic.homeImage = this.vc.homeImage;
    }

    if (this.images) {
      this.images = this.images.filter(e => e.uuid !== image.uuid);
    }
  }

  onCancelEdit() {
    if (this.images && this.images.length > 0) {
      console.log(this.images);
      this.markUnsavedChanges();
    }
    if (this.hasUnsavedChanges) {
      this.commonUtils.presentYesNoActionSheet('Masz niezapisane zmiany, czy na pewno chcesz zrezygnować z edycji kliniki?', 'Tak', 'Nie', 'checkmark', 'close', () => {
        this.cancelVetClinicEditedEmitter.emit(true);
        this.hasUnsavedChanges = false;
      }, () => {
      });
    } else {
      this.commonUtils.presentYesNoActionSheet('Czy na pewno chcesz zrezygnować z edycji kliniki?', 'Tak', 'Nie', 'checkmark-outline', 'close', () => {
        this.cancelVetClinicEditedEmitter.emit(true);
        this.hasUnsavedChanges = false;
      }, () => {
      });
    }
  }

  reorderImage(event: CustomEvent<ItemReorderEventDetail>) {
    this.vetClinicGallery = this.commonUtils.immutableArrayMove(this.vetClinicGallery, event.detail.from, event.detail.to);
    this.markUnsavedChanges();
    event.detail.complete();
  }

  removeImage(idx: number) {
    if (this.vetClinicGallery[idx] !== undefined) {
      this.commonUtils.presentYesNoActionSheet(`Na pewno chcesz usunąć zdjęcie '${(this.vetClinicGallery[idx] as VImage).name}'?`, 'Tak', 'Nie', 'trash', 'close', () => {
        this.vetClinicGallery.splice(idx, 1);
        this.markUnsavedChanges();
      }, () => {
      });
    }
  }

  async addNewImage() {
    const modal = await this.modalController.create({
      component: VImageDropComponent,
      componentProps: {
        'multiple': false,
        'vetClinicUUID': this.vetClinic.uuid,
        'imageFolder': `gallery/${this.commonUtils.generateUUID()}`
      }
    });

    modal.onDidDismiss<VImage>().then((dismissData) => {
      if (dismissData && dismissData.data) {
        (this.vetClinicGallery as VImage[]).push(dismissData.data);
        if (this.images) {
          this.images.push(dismissData.data);
        } else {
          this.images = [];
          this.images.push(dismissData.data);
        }

        this.markUnsavedChanges();
      }
    });

    return await modal.present();
  }

  addNewService() {
    this.services.push('');
    this.servicesItems.push('');
  }

  onServiceChange(idx: number, event: CustomEvent<InputChangeEventDetail>) {
    if (this.servicesItems[idx] !== undefined) {
      this.servicesItems[idx] = event.detail.value;
      this.vetClinicGroup.get('servicesJson').setValue(JSON.stringify(this.servicesItems));
      this.markUnsavedChanges();
    }
  }

  removeService(idx: number) {
    if (this.servicesItems[idx] !== undefined) {
      this.commonUtils.presentYesNoActionSheet(`Na pewno chcesz usunąć usługę '${this.servicesItems[idx]}'?`, 'Tak', 'Nie', 'trash', 'close', () => {
        this.servicesItems.splice(idx, 1);
        this.services.splice(idx, 1);
        this.vetClinicGroup.get('servicesJson').setValue(JSON.stringify(this.servicesItems));
        this.markUnsavedChanges();
      }, () => {
      });
    }
  }

  async addVMsgDefaultImage() {
    const modal = await this.modalController.create({
      component: VImageDropComponent,
      componentProps: {
        'multiple': false,
        'vetClinicUUID': this.vetClinic.uuid,
        'imageFolder': 'v-msg-default'
      }
    });

    modal.onDidDismiss<VImage>().then((dismissData) => {
      if (dismissData && dismissData.data !== undefined && dismissData.data.uuid) {

        this.vetClinic.vMsgDefaultImg = dismissData.data;
        this.vetClinic.vMsgDefaultImgUUID = dismissData.data.uuid;
        // this.markUnsavedChanges();
        this.vetClinicGroup.get('vMsgDefaultImg').setValue(dismissData.data);

        if (this.images) {
          this.images.push(dismissData.data)
        } else {
          this.images = [];
          this.images.push(dismissData.data)
        }
      }
    });

    return await modal.present();
  }


  toggleAdvancedSetting() {
    if (this.advancedSettingsOpened) {
      this.advancedSettingsOpened = false;
    } else {
      this.advancedSettingsOpened = true;
    }
  }

  getAdvanceSettingsButtonIcon() {
    if (this.advancedSettingsOpened) {
      return 'chevron-up-outline';
    } else {
      return 'chevron-down-outline';
    }
  }


  private markUnsavedChanges() {
    if (!this.hasUnsavedChanges) {
      this.hasUnsavedChangesEmitter.emit(true);
      this.hasUnsavedChanges = true;
    }
  }

  onSave() {
    if(!this.visitSyncHourMode) {
      this.vetClinicGroup.removeControl('visitSyncHour');
    }

    // if(this.paymentsEnabled && (this.reservationCancellationRefund === null || this.reservationCancellationRefund < 0)) {
    //   this.commonUtils.presentAlertToast("Proszę uzupełnić procent z kwoty vouchera do potrącenia przy standardowych");
    //   return;
    // }

    if (this.vetClinicGroup.valid) {
      // if (this.vrAutoLockEndHour) {
      //   if (!this.isHour(this.vrAutoLockEndHour)) {
      //     this.vetClinicGroup.markAllAsTouched();
      //     this.commonUtils.presentAlertToast("Proszę poprawić godzinę automatycznej blokady rezerwacji porannych - np: 10:00");
      //     return;
      //   }
      // } else {
      //   if (this.vrAutoLockMode) {
      //     this.vetClinicGroup.markAllAsTouched();
      //     this.commonUtils.presentAlertToast("Proszę poprawić godzinę automatycznej blokady rezerwacji porannych - np: 10:00");
      //     return;
      //   }
      // }

      let visitTypesOk = true;

      if (visitTypesOk && this.cityDataAreValid()) {
        this.commonUtils.presentYesNoActionSheet('Na pewno chcesz zapisać zmiany?', 'Tak', 'Nie', 'checkmark-outline', 'close', () => {
          let vetClinicEdited: VetClinic = this.commonUtils.formGroupValuesToObject<VetClinic>(new VetClinic(), this.vetClinicGroup);
          this.appStateService.updateIsBusySubject(true);

          this.vetClinic.homeImageUUID =vetClinicEdited.homeImageUUID;
          this.vetClinic.about = vetClinicEdited.about;
          this.vetClinic.servicesJson = JSON.stringify(this.servicesItems);
          this.vetClinic.sendTechnicalAlerts = vetClinicEdited.sendTechnicalAlerts;
          this.vetClinic.technicalAlertsEmail = vetClinicEdited.technicalAlertsEmail;
          this.vetClinic.hoursToSendReminder =vetClinicEdited.hoursToSendReminder;
          this.vetClinic.invoiceOfficeEmail =vetClinicEdited.invoiceOfficeEmail;
          this.vetClinic.percentageRefundValueAfterExpiration = vetClinicEdited.percentageRefundValueAfterExpiration;
          this.vetClinic.useCustomSchedule = this.useCustomSchedule;
          this.vetClinic.vetVisitTypes =null;
          this.vetClinic.pragmaticBoxCode = vetClinicEdited.pragmaticBoxCode;
          this.vetClinic.cityName = this.cityName;

          this.vetClinic.cityRegion = this.selectedCityRegion;

          if (this.isGeneralAdmin || this.isGeneralClientAdmin) {
            this.vetClinic.paymentsEnabled = this.paymentsEnabled;
            this.vetClinic.messagesEnabled = this.messagesEnabled;
          }

          if(this.legalVersion){
            this.vetClinic.legalVer = 'V2';
          } else {
            this.vetClinic.legalVer = 'V1';
          }

          if(this.reservationCancellationRefund){
            this.vetClinic.reservationCancellationRefund = this.reservationCancellationRefund;
          }
          this.vetClinic.showAllFreeTerms = this.showAllFreeTerms;

          this.vetClinic.voucherInfoFirstInSubject = this.voucherInfoFirstInSubject;
          this.vetClinic.voucherSellInfo = vetClinicEdited.voucherSellInfo;
          this.vetClinic.vetineoPromotionEmailAddon = vetClinicEdited.vetineoPromotionEmailAddon;
          this.vetClinic.sendConfirmNotification = vetClinicEdited.sendConfirmNotification;
          this.vetClinic.visitSyncDelayMinutes = vetClinicEdited.visitSyncDelayMinutes;
          this.vetClinic.visitSyncHour = vetClinicEdited.visitSyncHour;
          if (this.isGeneralAdmin || this.isGeneralClientAdmin) {
            this.vetClinic.displayName = vetClinicEdited.displayName;
          }
          this.vetClinic.disableCheckKlinikaXpSync = this.disableCheckKlinikaXpSync;

          if(this.startSyncDate != null){
            this.vetClinic.dateSinceSyncVisitStarted = this.startSyncDate.split('T')[0];
          }

          if(this.isOldRecommendationsSyncBlocked != null){
            this.vetClinic.isOldRecommendationsSyncBlocked = this.isOldRecommendationsSyncBlocked;
          }

          if(this.isOldLabTestDataBlocked !== null ){
            this.vetClinic.isOldLabTestDataBlocked = this.isOldLabTestDataBlocked;
          }
          if(this.isSendExtendedNotifications !== null) {
            this.vetClinic.sendExtendedNotifications = this.isSendExtendedNotifications;
          }

          if(this.sendVisitTypeAdditionalInfo != null){
            this.vetClinic.sendVisitTypeAdditionalInfo = this.sendVisitTypeAdditionalInfo;
          }
          if(this.visitUpdateSyncPushBlock != null){
            this.vetClinic.visitUpdateSyncPushBlock = this.visitUpdateSyncPushBlock;
            if(this.visitUpdateSyncPushBlock) {
              if (this.visitUpdateSyncPushBlockValue !== '') {
                this.vetClinic.visitUpdateSyncPushBlockValue = this.visitUpdateSyncPushBlockValue;
              } else {
                this.vetClinic.visitUpdateSyncPushBlockValue = 1;
              }
            }
          }
          if(this.visitSyncHourMode != null){
            this.vetClinic.visitSyncHourMode = this.visitSyncHourMode;
          }

          if (this.vrAutoLockMode) {
            this.vetClinic.vrAutoLockMode = 1;
          } else {
            this.vetClinic.vrAutoLockMode = 0;
          }

          this.vetClinic.vrAutoLockEndHour = this.vrAutoLockEndHour;

          const galleryImages: VetClinicPhotoGalleryImage[] = (this.vetClinicGallery as VImage[])?.map((vImage, idx) => {
            return new VetClinicPhotoGalleryImage(idx, this.vetClinic.uuid, vImage.uuid);
          });

          if(this.isGeneralAdmin || this.isGeneralClientAdmin){
            this.vetClinic.cancellationPageUrl =vetClinicEdited.cancellationPageUrl;
          }

          this.vetClinic.gallery = galleryImages;

          if (this.addPartner && this.isGeneralAdmin) {
            this.vetClinic.partnerVClientId = this.partnerToChange.id;
          }

          this.vetClinic.vImagesToSetAsActive = this.images?.map(e => e.uuid)

          // this.vetClinic.vMsgDefaultImgUUID = this.vetClinic.vMsgDefaultImgUUID;
          this.vetClinicService.updateVetClinic(this.vetClinic)
            .subscribe((vc: VetClinic) => {
                this.commonUtils.presentInfoToast("Dane lecznicy zostały zmienione").then(res => {
                });
                this.hasUnsavedChanges = false;
                this.vetClinic = null;
                this.partner = null;
                this.partnerUUID = null;
                this.partnerToChange = null;
                this.partnerAction = 'przypisz partnera';
                this.appStateService.updateIsBusySubject(false);
                this.vetClinicEditedEmitter.emit(vc);
              },
              error => {
                this.appStateService.updateIsBusySubject(false);
                this.commonUtils.presentAlertToast("Wystąpił błąd podczas zmiany danych lecznicy");
              });
        }, () => {
        });
      } else {
        this.commonUtils.presentAlertToast("Formularz nie jest wypełniony poprawnie")
      }
    } else {
      this.vetClinicGroup.markAllAsTouched();
      this.commonUtils.presentAlertToast("Formularz nie jest wypełniony poprawnie")
    }

  }

  changeCalendarValue($event) {
    this.startSyncDate = $event.detail.value;
  }

  getPushBlockLines() {
    return this.visitUpdateSyncPushBlock ? 'none' : 'full';
  }

  getPushBlockClass() {
    if (!this.pushBlockValueRegex.test(String(this.visitUpdateSyncPushBlockValue))) {
      return 'ng-invalid';
    }
    return '';
  }

  pushBlockValueChange($event) {
    const isValid = !$event.detail.value || this.pushBlockValueRegex.test($event.detail.value);
    if (isValid) {
      this.visitUpdateSyncPushBlockValue = $event.detail.value;
    } else {
      if(!this.alertPresented) {
        this.alertPresented = true;
        this.commonUtils.presentAlertToast('Proszę podać liczbę z przedziału od 1 do 8', 3000);
        setTimeout(() => this.alertPresented = false, 3000);
      }
      this.visitUpdateSyncPushBlockValue = 1;
    }
  }

  cityDataAreValid() {
    return this.cityName && this.selectedCityRegion
  }
}
